import { updateDiagramStartLabel, getDiagramStartLabel } from '@process-advisor/process-miner/processMiner/processMiner';
import { updateDiagramEndLabel, getDiagramEndLabel } from '@process-advisor/process-miner/processMiner/processMiner';

export type StartLabelProps = {
    visible?: boolean;
}

export type EndLabelProps = {
    visible?: boolean;
}
export const changeStartLabel = ({
    visible,
}: EndLabelProps) => updateDiagramStartLabel({
    visible,
});

export const changeEndLabel = ({
    visible,
}: EndLabelProps) => updateDiagramEndLabel({
    visible,
});

export const getStartLabel = (): StartLabelProps => getDiagramStartLabel();
export const getEndLabel = (): EndLabelProps => getDiagramEndLabel();
